__turbopack_context__.v({
  "contentWrapper": "helpTitle-module-scss-module__sbXAQW__contentWrapper",
  "details": "helpTitle-module-scss-module__sbXAQW__details",
  "headline": "helpTitle-module-scss-module__sbXAQW__headline",
  "headlineOnly": "helpTitle-module-scss-module__sbXAQW__headlineOnly",
  "icon": "helpTitle-module-scss-module__sbXAQW__icon",
  "mainContainer": "helpTitle-module-scss-module__sbXAQW__mainContainer",
});
